import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./styles.css";

class Welcome extends Component {
  // welcome page after new user sign up
  render() {
    return (
      <div className="d-flex h-100 justify-content-center background-image">
        <div className="align-self-md-center h-auto w-40 p-4 form-container ">
          <p className="login-title">WELCOME!</p>
          <p className='myp'>You have successfully registered a new account.</p>
          <p className='myp'>
            We have sent you an email. Please click on the confirmation link to
            verify your account.
          </p>
          <Link
            to="/login"
            className=" btn btn-link btn-block font-weight-bold link"
          >
            CLICK HERE TO LOG INTO YOUR PERSONAL ACCOUNT
          </Link>
        </div>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/routes/welcome/index.js